module.exports = __webpack_public_path__ + "resources/threaded-message-d845cc3f982f9f77bdd6eab5a5fedf3b.svg";